/**
@format
@flow
*/
import type { MongoIdType } from '@ziynx/flow-types/globals';

const isDev: boolean = process.env.REACT_APP_DEVELOPMENT === 'true';

type IndustryType = {
  value: string,
  name: string,
  _id?: MongoIdType,
};

const PROD_INDUSTRIES: Array<IndustryType> = [
  {
    value: '',
    name: '',
  },
  {
    value: '60abc80c817bd6000fcc9346',
    name: 'Accounting',
  },
  {
    value: '60abc80c817bd6000fcc9347',
    name: 'Apparel & Fashion',
  },
  {
    value: '60abc80c817bd6000fcc9348',
    name: 'Architecture ',
  },
  {
    value: '60abc80c817bd6000fcc9349',
    name: 'Automotive',
  },
  {
    value: '60abc80c817bd6000fcc934c',
    name: 'Biotechnology',
  },
  {
    value: '60abc80c817bd6000fcc934a',
    name: 'Cannabis',
  },
  {
    value: '60abc80c817bd6000fcc934b',
    name: 'Commercial Banking ',
  },
  {
    value: '60abc80c817bd6000fcc934d',
    name: 'Computer Games',
  },
  {
    value: '60abc80c817bd6000fcc934e',
    name: 'Computer Hardware',
  },
  {
    value: '60abc80c817bd6000fcc934f',
    name: 'Computer Software',
  },
  {
    value: '60abc80c817bd6000fcc9350',
    name: 'Construction',
  },
  {
    value: '60abc80c817bd6000fcc9351',
    name: 'Consumer Electronics',
  },
  {
    value: '60abc80c817bd6000fcc9352',
    name: 'Consumer Packaged Goods',
  },
  {
    value: '60abc80c817bd6000fcc9353',
    name: 'Consumer Services',
  },
  {
    value: '60abc80c817bd6000fcc9354',
    name: 'Cosmetics',
  },
  {
    value: '60abc80c817bd6000fcc9355',
    name: 'E-learning',
  },
  {
    value: '60abc80c817bd6000fcc9356',
    name: 'Education Services',
  },
  {
    value: '60abc80c817bd6000fcc936e',
    name: 'Energy & Natural Resources',
  },
  {
    value: '60abc80c817bd6000fcc9357',
    name: 'Environmental Services',
  },
  {
    value: '60abc80c817bd6000fcc9358',
    name: 'Facilities Services',
  },
  {
    value: '60abc80c817bd6000fcc9359',
    name: 'Financial Services',
  },
  {
    value: '60abc80c817bd6000fcc935a',
    name: 'Food & Beverages',
  },
  {
    value: '60abc80c817bd6000fcc935b',
    name: 'Fundraising',
  },
  {
    value: '60abc80c817bd6000fcc9362',
    name: 'Government, Policy & Law',
  },
  {
    value: '60abc80c817bd6000fcc935d',
    name: 'Health Care',
  },
  {
    value: '60abc80c817bd6000fcc935c',
    name: 'Health, Wellness & Fitness',
  },
  {
    value: '60abc80c817bd6000fcc935e',
    name: 'Human Resources & Recruiting ',
  },
  {
    value: '60abc80c817bd6000fcc935f',
    name: 'Information Technology & Services',
  },
  {
    value: '60abc80c817bd6000fcc9360',
    name: 'Insurance',
  },
  {
    value: '60abc80c817bd6000fcc9361',
    name: 'Investment Banking',
  },
  {
    value: '60abc80c817bd6000fcc9363',
    name: 'Leisure, Travel & Tourism',
  },
  {
    value: '60abc80c817bd6000fcc9364',
    name: 'Logistics & Supply Chain',
  },
  {
    value: '60abc80c817bd6000fcc9365',
    name: 'Luxury Goods & Jewelry',
  },
  {
    value: '60abc80c817bd6000fcc9366',
    name: 'Management Consulting',
  },
  {
    value: '60abc80c817bd6000fcc9367',
    name: 'Market Research',
  },
  {
    value: '60abc80c817bd6000fcc9368',
    name: 'Marketing and Advertising',
  },
  {
    value: '60abc80c817bd6000fcc9369',
    name: 'Mechanical Engineering',
  },
  {
    value: '60abc80c817bd6000fcc936a',
    name: 'Media & Entertainment ',
  },
  {
    value: '60abc80c817bd6000fcc936b',
    name: 'Medical Device',
  },
  {
    value: '60abc80c817bd6000fcc936c',
    name: 'Music',
  },
  {
    value: '60abc80c817bd6000fcc936d',
    name: 'Non-profit',
  },
  {
    value: '60abc80c817bd6000fcc936f',
    name: 'Pharmaceuticals',
  },
  {
    value: '60abc80c817bd6000fcc9370',
    name: 'Public Relations',
  },
  {
    value: '60abc80c817bd6000fcc9371',
    name: 'Real Estate',
  },
  {
    value: '60abc80c817bd6000fcc9372',
    name: 'Restaurants',
  },
  {
    value: '60abc80c817bd6000fcc9373',
    name: 'Retail',
  },
  {
    value: '60abc80c817bd6000fcc9374',
    name: 'Sports',
  },
  {
    value: '60abc80c817bd6000fcc9375',
    name: 'Transportation',
  },
  {
    value: '60abc80c817bd6000fcc9376',
    name: 'Venture Capital & Private Equity',
  },
  {
    value: '60abc80c817bd6000fcc9378',
    name: 'Wealth Management',
  },
  {
    value: '60abc80c817bd6000fcc9377',
    name: 'Wholesale',
  },
];

const DEV_INDUSTRIES: Array<IndustryType> = [
  {
    value: '',
    name: '',
  },
  {
    value: '60abc461e7f095000e0ed821',
    name: 'Accounting',
  },
  {
    value: '60abc461e7f095000e0ed822',
    name: 'Apparel & Fashion',
  },
  {
    value: '60abc461e7f095000e0ed823',
    name: 'Architecture ',
  },
  {
    value: '60abc461e7f095000e0ed824',
    name: 'Automotive',
  },
  {
    value: '60abc461e7f095000e0ed827',
    name: 'Biotechnology',
  },
  {
    value: '60abc461e7f095000e0ed825',
    name: 'Cannabis',
  },
  {
    value: '60abc461e7f095000e0ed826',
    name: 'Commercial Banking ',
  },
  {
    value: '60abc461e7f095000e0ed828',
    name: 'Computer Games',
  },
  {
    value: '60abc461e7f095000e0ed829',
    name: 'Computer Hardware',
  },
  {
    value: '60abc461e7f095000e0ed82a',
    name: 'Computer Software',
  },
  {
    value: '60abc461e7f095000e0ed82b',
    name: 'Construction',
  },
  {
    value: '60abc461e7f095000e0ed82c',
    name: 'Consumer Electronics',
  },
  {
    value: '60abc461e7f095000e0ed82d',
    name: 'Consumer Packaged Goods',
  },
  {
    value: '60abc461e7f095000e0ed82e',
    name: 'Consumer Services',
  },
  {
    value: '60abc461e7f095000e0ed82f',
    name: 'Cosmetics',
  },
  {
    value: '60abc461e7f095000e0ed830',
    name: 'E-learning',
  },
  {
    value: '60abc461e7f095000e0ed831',
    name: 'Education Services',
  },
  {
    value: '60abc461e7f095000e0ed849',
    name: 'Energy & Natural Resources',
  },
  {
    value: '60abc461e7f095000e0ed832',
    name: 'Environmental Services',
  },
  {
    value: '60abc461e7f095000e0ed833',
    name: 'Facilities Services',
  },
  {
    value: '60abc461e7f095000e0ed834',
    name: 'Financial Services',
  },
  {
    value: '60abc461e7f095000e0ed835',
    name: 'Food & Beverages',
  },
  {
    value: '60abc461e7f095000e0ed836',
    name: 'Fundraising',
  },
  {
    value: '60abc461e7f095000e0ed83d',
    name: 'Government, Policy & Law',
  },
  {
    value: '60abc461e7f095000e0ed838',
    name: 'Health Care',
  },
  {
    value: '60abc461e7f095000e0ed837',
    name: 'Health, Wellness & Fitness',
  },
  {
    value: '60abc461e7f095000e0ed839',
    name: 'Human Resources & Recruiting ',
  },
  {
    value: '60abc461e7f095000e0ed83a',
    name: 'Information Technology & Services',
  },
  {
    value: '60abc461e7f095000e0ed83b',
    name: 'Insurance',
  },
  {
    value: '60abc461e7f095000e0ed83c',
    name: 'Investment Banking',
  },
  {
    value: '60abc461e7f095000e0ed83e',
    name: 'Leisure, Travel & Tourism',
  },
  {
    value: '60abc461e7f095000e0ed83f',
    name: 'Logistics & Supply Chain',
  },
  {
    value: '60abc461e7f095000e0ed840',
    name: 'Luxury Goods & Jewelry',
  },
  {
    value: '60abc461e7f095000e0ed841',
    name: 'Management Consulting',
  },
  {
    value: '60abc461e7f095000e0ed842',
    name: 'Market Research',
  },
  {
    value: '60abc461e7f095000e0ed843',
    name: 'Marketing and Advertising',
  },
  {
    value: '60abc461e7f095000e0ed844',
    name: 'Mechanical Engineering',
  },
  {
    value: '60abc461e7f095000e0ed845',
    name: 'Media & Entertainment ',
  },
  {
    value: '60abc461e7f095000e0ed846',
    name: 'Medical Device',
  },
  {
    value: '60abc461e7f095000e0ed847',
    name: 'Music',
  },
  {
    value: '60abc461e7f095000e0ed848',
    name: 'Non-profit',
  },
  {
    value: '60abc461e7f095000e0ed84a',
    name: 'Pharmaceuticals',
  },
  {
    value: '60abc461e7f095000e0ed84b',
    name: 'Public Relations',
  },
  {
    value: '60abc461e7f095000e0ed84c',
    name: 'Real Estate',
  },
  {
    value: '60abc461e7f095000e0ed84d',
    name: 'Restaurants',
  },
  {
    value: '60abc461e7f095000e0ed84e',
    name: 'Retail',
  },
  {
    value: '60abc461e7f095000e0ed84f',
    name: 'Sports',
  },
  {
    value: '60abc461e7f095000e0ed850',
    name: 'Transportation',
  },
  {
    value: '60abc461e7f095000e0ed851',
    name: 'Venture Capital & Private Equity',
  },
  {
    value: '60abc461e7f095000e0ed853',
    name: 'Wealth Management',
  },
  {
    value: '60abc461e7f095000e0ed852',
    name: 'Wholesale',
  },
];

const INDUSTRIES: Array<IndustryType> = isDev ? DEV_INDUSTRIES : PROD_INDUSTRIES;

export { INDUSTRIES };
